import _ from 'lodash';

export function localGatewayAndApmMapper(gateways, apms) {
    const gatewayTypeMapper = _.invert(gateways.gatewayList);

    const apmTypeMapper = _.reduce(apms, (acc, apm) => {
        acc[apm.connectorId] = apm.connectorName;

        return acc;
    }, {});

    return Object.assign({}, gatewayTypeMapper, apmTypeMapper);
}

export function getSortedGatewayAndApmMapperArray(gateways, apms) {
    const gatewayAndApmKeyValuePairs = _.mapValues(localGatewayAndApmMapper(gateways, apms), (value, key) => {
        return { name: value, key };
    });

    const sortedGatewayAndApmMapper = _.orderBy(gatewayAndApmKeyValuePairs, ['name']);
    const sortedGatewayAndApmMapperArray = _.map(sortedGatewayAndApmMapper, (value) => {
        return [value.key, value.name];
    });

    return sortedGatewayAndApmMapperArray;
}

export function isKount360(transaction) {
    try {
        const omniscore = _.get(transaction, 'order.riskInquiry.omniscore');
        const version = _.get(transaction, 'version');
        if (omniscore) return true;
        if (version) {
            const match = version.match(/^v?(\d+)/i);
            if (match && parseInt(match[1], 10) >= 2) {
                return true;
            }
        }

        return false;
    } catch (err) {
        return false;
    }
}
